import React from "react";
import {CustomCloseModalIcon} from "./icons/custom-close-modal-icon";
import marketBook from "../../img/market-book.png";
import {Grid} from "@mui/material";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {StyledButton} from "./button";
import {useHistory} from "react-router-dom";

export const SuccessModal: React.FC<{open: boolean, setOpen: Function, title: string, description?: string, buttonText?: string, buttonLink?: string, buttonClick?: Function}> = ({open, setOpen, title, description, buttonLink, buttonText, children, buttonClick}) => {
    const history = useHistory();

    const buttonNavigate = () => {
        history.push(buttonLink);
        setOpen(false);
    }

    return (
        <>
        {open &&
        <StyledBlockedContent container direction={"column"} justifyContent={"center"} alignContent={"center"}>
            <StyledBlockedInfo item container direction={"column"} alignItems={"center"} spacing={2}>
                <StyledCloseButton onClick={() => {
                    setOpen(false);
                }}><CustomCloseModalIcon/></StyledCloseButton>

                <StyledBlockedImgContainer item>
                    <img src={marketBook} alt='book'/>
                </StyledBlockedImgContainer>

                <Grid item style={{padding: '0'}}>
                    <StyledBlockedTitle>{title}</StyledBlockedTitle>
                </Grid>

                <Grid item style={{padding: '0'}}>
                    <StyledBlockedDescription>{description || children}</StyledBlockedDescription>
                </Grid>

                {buttonText && buttonLink &&
                <Grid item style={{padding: '0'}}>
                    <StyledButton type={"button"} color={"violet"} onClick={buttonNavigate}>{buttonText}</StyledButton>
                </Grid>
                }

                {buttonText && buttonClick &&
                <Grid item style={{padding: '0'}}>
                    <StyledButton type={"button"} color={"violet"} onClick={buttonClick}>{buttonText}</StyledButton>
                </Grid>
                }
            </StyledBlockedInfo>
        </StyledBlockedContent>
        }
        </>
    );
}

const StyledBlockedContent = styled(Grid)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.8561799719887955);
  z-index: 1111111;
`;

const StyledBlockedInfo = styled(Grid)`
  background: #FBF5FF;
  border: 1px solid ${Colors.lightViolet};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  max-width: 400px !important;
  position: relative;
  padding-bottom: 1rem;
`;

const StyledBlockedImgContainer = styled(Grid)`
  padding: 0 !important;
`;

const StyledBlockedTitle = styled('h6')`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${Colors.lightViolet};
  text-align: center;
  padding: 0 10px !important;
`;

const StyledBlockedDescription = styled('h6')`
  font-size: 0.9rem;
  font-weight: 500;
  color: ${Colors.lightViolet};
  text-align: center;
  padding: 20px 10px !important;
`;

const StyledCloseButton = styled('div')`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;
